import { createIcon } from '@chakra-ui/icons';

export const Explore = createIcon({
  displayName: 'Explore',
  viewBox: '0 0 16 16',
  d: 'M8.88889 5.33333V0H16V5.33333H8.88889ZM0 8.88889V0H7.11111V8.88889H0ZM8.88889 16V7.11111H16V16H8.88889ZM0 16V10.6667H7.11111V16H0Z',
});
